"use client";

import { useTranslations } from "next-intl";
import { cn } from "@apg.gg/core/lib/cn";
import Image from 'next/image';
import { useRouter } from "next-nprogress-bar";
import Button from "@apg.gg/core/lib/Button";
import { useParams } from "next/navigation";

export default function HeroSectionClient() {
  const router = useRouter();
  const { locale } = useParams();
  const t = useTranslations('Home');

  return (
    <section id="home" className={
      cn(
        "bg-cover bg-no-repeat bg-center pb-16 relative"
      )
    } style={{ backgroundImage: 'url(/assets/resources/home-bg-main@2x.png)' }}>
      <div className="container h-full lg:max-w-full">
        <div className="flex flex-col items-center gap-4 relative pt-10 h-full">
          <Image src="/assets/resources/isotipo-white.png" alt='APG.gg' width={162} height={61} />

          <div className="flex flex-col items-center gap-4 justify-center">
            <h1 className="uppercase text-display-sm sm:text-display-lg text-center max-w-4xl text-balance">{t("empower-your-streams-with-our-tools")}</h1>
            <p className="text-2xl font-source-sans-pro text-center text-balance max-w-6xl">{t("our-platform-offers-a-suite-of-advanced-tools-to-enhance-your-tournament-experience-and-take-your-users-experience-to-the-next-level")}</p>

            <Button
              type="primary"
              className="px-8 py-4 text-title-lg"
              onClick={() => {
                router.push(`/${locale}/auth/login`);
              }}
            >
             {t("get-started")}
            </Button>
          </div>

          <Image 
            src="/assets/resources/hero-section.png" 
            alt='APG.gg' 
            width={1438} 
            height={787}
            className="max-w-5xl object-cover object-center rounded-xl w-full mask-image-black-to-transparent"
          />
        </div>
      </div>

      <div className="absolute hero-gradient-900 -bottom-8 left-0 w-full h-40"></div>
    </section>
  )
}